export default "__VITE_ASSET__CgWjAzSK__"